import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mission-voting-camping',
  templateUrl: './mission-voting-camping.component.html',
  styleUrls: ['./mission-voting-camping.component.scss']
})
export class MissionVotingCampingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
